import './Title.css';
import React from 'react';

interface TitleProps {
    title: string;
    position?: string;
}
export const Title: React.FC<TitleProps> = ({ title, position = 'center' }) => {
    return (
        <div className={`title title_position_${position}`}>
            <h1 className={`title__text title__text_position_${position}`}>{title}</h1>
        </div>
    );
};
